export default "__VITE_ASSET__B0ysohwh__"